import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { logError } from "@/lib/logger";
import { savePurchase } from "@/lib/purchases";
import { useCustomer } from "@/context/CustomerContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useCustomer();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    (async () => {
      const match = location.hash.match(/session_id=([^&]+)/);
      const sessionId = match ? match[1] : "";
      try {
        const { data: user } = await api.post("/customer/session", { session_id: sessionId });
        try {
          const { data: purchases } = await api.get("/customer/purchases");
          purchases.forEach((p) => savePurchase(p.ebook_id, p.session_id));
        } catch (err) {
          logError("Purchase sync failed", err);
        }
        await refresh();
        navigate("/studio/purchases", { replace: true, state: { user } });
      } catch (err) {
        logError("Sign-in failed", err);
        navigate("/studio/purchases", { replace: true, state: { authError: true } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#030303] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <div className="h-6 w-6 rounded-full border-2 border-white/15 border-t-[#F59E0B] animate-spin" />
      <p className="text-white/40 font-serif italic">Signing you in...</p>
    </div>
  );
};
